export class Regexes {
  public static emailRegex =
    '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$';

  public static passwordRegex = '(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{8,}';

  public static postcodeRegex = '^[A-Z]{1,2}\\d[A-Z\\d]?\\s?\\d[A-Z]{2}$';
}
